require("@rails/ujs").start()
require("@rails/activestorage").start()

import 'core-js/stable' // ES6 polyfills
import 'unpoly/unpoly.es6.js'
import 'unpoly/unpoly-bootstrap5.js'

import * as Popper from '@popperjs/core'
window.Popper = Popper
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap
import '@fortawesome/fontawesome-free/js/all'
import 'chartkick/chart.js'
const _TomSelect = require('tom-select/dist/js/tom-select.complete.js')
window.TomSelect = _TomSelect.default || _TomSelect
import { DateTimePicker } from '@taslerit/datetimepicker'
window.DateTimePicker = DateTimePicker
import 'bs-stepper'
import 'sortablejs'
import print from 'print-js'

import { Dropzone } from "dropzone";
Dropzone.autoDiscover = false;

// JavaScript
let webpackContext = require.context('../javascripts', true, /\.js(\.erb)?$/)
for(let key of webpackContext.keys()) { webpackContext(key) }

// Images
require.context('../images', true, /\.(?:png|jpg|gif|ico|svg)$/)

// Stylesheets
import '../stylesheets/custom_bootstrap'
import 'unpoly/unpoly.css'
import 'unpoly/unpoly-bootstrap5.css'
import 'dropzone/dist/dropzone.css'
import 'tom-select/dist/css/tom-select.bootstrap5.css'
import '@taslerit/datetimepicker/dist/datetimepicker.css'
import 'bs-stepper/dist/css/bs-stepper.min.css'
import 'print-js/dist/print.css'

require.context('../stylesheets/blocks', true, /\.s[ac]ss(\.erb)?$/)
require.context('../stylesheets/ext', true, /\.s?[ac]ss(\.erb)?$/)
require.context('../stylesheets/general', true, /\.s?[ac]ss(\.erb)?$/)
